import { gql } from '@/services/api';

export const CategoryFragment = gql`
  fragment CategoryFragment on CategoriesNamespaceType {
    get(id: $category) {
      products(pagination: { first: 9, sortBy: POPULARITY }) {
        edges {
          node {
            id
            name
            category {
              name
              id
            }
            media {
              type
              source
            }
          }
        }
      }
    }
  }
`;

export const HomePage = gql`
  ${CategoryFragment}
  query HomePage($category: ID!) {
    Category {
      ...CategoryFragment
    }
    User {
      find(pagination: { first: 10, sortBy: POPULARITY }, filters: { level: STAR }) {
        edges {
          node {
            id
            name
            lastname
            nickname
            avatar
            level {
              id
              name
            }
            recommendations {
              total
            }
            collections(pagination: { first: 2, sortBy: UPDATED }) {
              edges {
                node {
                  id
                  name
                  media {
                    type
                    source
                  }
                  content {
                    total
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
